export default __webpack_public_path__ + "static/media/5_image_2.e1fa9ce9.png";